import { chatService } from '@/services'

export default {
  state: {
    messages: [],
    depthPageMessages: [],
    countMessages: 0,
    hasUnreadMessages: false,
    chatMutedAt: null
  },

  mutations: {
    setMessage (state, value) {
      const messages = state.messages
      messages.push(value)

      if (value.messageStatus.status === 'unread') {
        state.hasUnreadMessages = true
      }

      state.messages = messages
    },

    setMessages (state, value) {
      if (value.messages.some(item => item.messageStatus.status === 'unread')) {
        state.hasUnreadMessages = true
      }

      state.messages = value.messages.reverse()
      state.countMessages = value.count
    },

    addMessages (state, value) {
      const messages = state.messages

      messages.unshift(...value.reverse())

      state.messages = messages
    },

    addDepthPageMessage (state, value) {
      let messages = state.depthPageMessages

      if (messages.some(item => item.id === value.id)) {
        messages = messages.map(item => {
          if (item.id === value.id) return value
          return item
        })
      } else {
        messages.push(value)
      }

      state.depthPageMessages = messages
    },

    setDepthPageMessages (state, value) {
      state.depthPageMessages = value.messages.reverse()
    },

    updateMessageStatus (state, value) {
      state.hasUnreadMessages = value
    },

    updateMessageSendStatus (state, { oldId, newId }) {
      const message = state.messages.find(item => item.id === oldId)

      if (message) {
        message.wasSent = true
        message.id = newId
      }
    },

    updateChatMutedAt (state, value) {
      state.chatMutedAt = value
    }
  },

  actions: {
    addMessage (_, { chatId, bookId, text, projectId }) {
      return chatService.addMessage({ chatId, bookId, text, projectId })
    },

    getMessages ({ commit }, { chatId, bookId, page = 0 }) {
      return chatService.getMessages({ chatId, bookId, page })
        .then(({ data }) => commit('setMessages', data))
    },

    getDepthPageMessages ({ commit }, { chatId, bookId, page = 0 }) {
      return chatService.getMessages({ chatId, bookId, page })
        .then(({ data }) => commit('setDepthPageMessages', data))
    },

    fetchMessages ({ commit }, { chatId, bookId, page = 0 }) {
      return chatService.getMessages({ chatId, bookId, page })
        .then(({ data }) => commit('addMessages', data.messages))
    },

    updateMessageStatus ({ commit }, { chatId }) {
      chatService.updateMessageStatus({ chatId: chatId })
        .then(() => commit('updateMessageStatus', false))
    }
  }
}
